import { Component, OnInit } from '@angular/core';
import { MMobileHelperService } from '@core/services/core/mmobile-helper.service';
import { UrlHelper } from '@core/services/helpers/url-helper.service';
import { LoginFooterLinks, SocialMediaFooterIcon } from '@modules/login/models';

@Component({
  selector: 'app-mapfre-login-footer',
  templateUrl: './mapfre-login-footer.component.html',
  styleUrls: ['./mapfre-login-footer.component.scss'],
})
export class MapfreLoginFooterComponent implements OnInit {
  links: LoginFooterLinks[];
  socialMediaIcons: SocialMediaFooterIcon[];

  readonly year: string;
  private readonly baseSocialMediaIconPath: string;

  constructor(
    public url: UrlHelper,
    private mmobileHelper: MMobileHelperService
  ) {
    this.baseSocialMediaIconPath = 'assets/images/login/business-';
    this.year = new Date().getFullYear().toString();
    this.socialMediaIcons = this.getSocialMediaIcons();
  }

  async ngOnInit() {
    this.links = await this.getLinks();
  }

  getSocialMediaIcons() {
    return [
      {
        path: `${this.baseSocialMediaIconPath}phone-icon.svg`,
        url: 'https://www.mapfre.es/movil'
      },
      {
        path: `${this.baseSocialMediaIconPath}instagram-icon.svg`,
        url: 'https://www.instagram.com/mapfre_es/'
      },
      {
        path: `${this.baseSocialMediaIconPath}facebook-icon.svg`,
        url: 'https://es-es.facebook.com/MAPFRE.ES/'
      },
      {
        path: `${this.baseSocialMediaIconPath}twitter-icon.svg`,
        url: 'https://twitter.com/MAPFRE_ES'
      },
      {
        path: `${this.baseSocialMediaIconPath}youtube-icon.svg`,
        url: 'https://www.youtube.com/user/mapfretecuidamos'
      },
      {
        path: `${this.baseSocialMediaIconPath}linkedin-icon.svg`,
        url: 'https://www.linkedin.com/company/mapfre/'
      }
    ];
  }

  async getLinks() {
    await this.mmobileHelper.isReady();
    return this.mmobileHelper.getCustomConfigData('login', 'loginFooterLinks') || [];
  }

}
